import React, { useEffect, useState } from 'react'
import { faChartSimple, faClock, faGraduationCap, faRotate } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, LinearProgress } from '@mui/material'
import './styles.css'
import { useUserStorage } from '../../../../storage/user'
import { desmatricularCurso, MatricularCurso } from '../../../../Api'
import { useNavigate } from 'react-router-dom';
import { useCursosStorage } from '../../../../storage/cursos'
import { notify } from '../../../../components/Notify'

export default function ProgressoInfo({ selectedCurso, isMatriculado, setIsMatriculado }) {
    const navigate = useNavigate();
    const { user } = useUserStorage(state => state)
    /* const { setSelectedAula } = useUserStorage(state => state.dispatch) */
    const [totalAulas, setTotalAulas] = useState(0)
    const [assistido, setAssistido] = useState(0)
    const [percent, setPercent] = useState(0)
    const [infos, setInfos] = useState([
        { icon: faChartSimple, info: '', title: '' },
        { icon: faClock, info: '0', title: 'Duração' },
    ])

    const { cursosDoEstudante, cursosTotais } = useCursosStorage(state => state).dados
    const { setCursosDoEstudante, setCursosTotais, setSelectedAula } = useCursosStorage(state => state).dispatch

    useEffect(() => {

        var totalAulas = 0
        var assistido = 0
        selectedCurso?.modulos && selectedCurso?.modulos?.map(item => {
            item && item?.aulas?.map(value => {
                if (value.assistido) {
                    assistido++
                }
                totalAulas++
            })
        })


        const infos = [
            { icon: faChartSimple, info: selectedCurso?.nivel, title: '' },
            { icon: faClock, info: selectedCurso?.duracao, title: 'Duração' },
        ]

        setInfos(infos)

        setTotalAulas(totalAulas)
        setAssistido(assistido)
        setPercent((assistido * 100) / totalAulas)

    }, [selectedCurso])

    const matricular = () => { 
        MatricularCurso({ userId: localStorage.getItem("id"), cursoId: selectedCurso.id }).then(res => {
            notify('Curso matriculado com sucesso!')
            const maticuladoCurso = cursosTotais.filter(val => {
                if (selectedCurso.id == val.id) {
                    return val
                }
            })
 
            setCursosDoEstudante([...cursosDoEstudante, maticuladoCurso])
            setIsMatriculado(true)
        }).catch(err => { 
        })

    }
    
    const desMatricular = () => {

        desmatricularCurso({ userId: localStorage.getItem("id"), cursoId: selectedCurso.id }).then(res => {
            notify('Curso desmatriculado com sucesso!')
            /* const maticuladoCurso = cursosTotais.filter(val => {
                if (selectedCurso.id == val.id) {
                    return val
                }
            }) */
            
            setIsMatriculado(false)
            navigate("/painel");
            /* setCursosDoEstudante([...cursosDoEstudante, maticuladoCurso]) */
        }).catch(err => { 
        })

    }

    const goToAula = () => {
        setSelectedAula(selectedCurso?.modulos[0]?.aulas[0] || [])
        navigate("/aula");
    }

    return (
        <>
            <div style={{ border: '1px solid #ddd', borderRadius: '10px' }}>

                <div style={{ background: '#F4F6F9', height: '200px', padding: '30px', borderRadius: '10px 10px 0 0' }}>
                    <h3>Progresso do curso</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
                        <h4>{assistido}/{totalAulas}</h4>
                        <h4>{percent.toFixed(2) || 0}% Completo</h4>
                    </div>
                    <LinearProgress variant="determinate" value={percent} style={{ marginBottom: '20px' }} />

                    {selectedCurso?.complete ?
                        <>
                            <button style={{ marginTop: '40px' }} className='iniciar'>Emitir Certificado</button>
                        </>
                        :
                        <>
                            {isMatriculado ?
                                <button className='iniciar' onClick={goToAula}>Iniciar Curso</button>
                                :
                                <button className='iniciar' onClick={matricular}>Matricular no Curso</button>
                            }
                            {/* <button className='completo' onClick={goToAula}> Curso completo</button> */}
                        </>
                    }


                </div>
                <div style={{ background: '#fff', height: '50px', padding: '30px', borderRadius: '0 0 10px 10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div>

                        {infos.map(item => {
                            return (
                                <div>
                                    <TitleProgress title={item.title} info={item.info} icon={item.icon} />
                                </div>
                            )
                        })}
                    </div> 
                    {isMatriculado && <button className='iniciar' onClick={desMatricular}>Desmatricular</button>}

                </div>
            </div>
        </>
    )
}


function TitleProgress({ title, icon, info }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <FontAwesomeIcon icon={icon} size='1x' style={{ marginRight: '8px' }} />
            <h4 style={{ marginRight: '8px' }} >{info}</h4>
            <h4 style={{ marginRight: '8px' }} >{title}</h4>
        </div>
    )
}

